import { render } from "./edit_status_modal.vue?vue&type=template&id=33b92994"
import script from "./edit_status_modal.js?vue&type=script&lang=js"
export * from "./edit_status_modal.js?vue&type=script&lang=js"

import "./edit_status_modal.vue?vue&type=style&index=0&id=33b92994&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__